var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-with-gradient",style:(_vm.iconStyle)},[_c('svg-icon',{attrs:{"icon":_vm.icon,"width":20,"height":20}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }